module.exports = __webpack_public_path__ + "img/Welhaven_Nyere_Digte.fb835ed7.jpg";